import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GrundbuchgeschaeftItem, KompaktGrundbuchgeschaeftPipe } from './kompakt-grundbuchgeschaeft.pipe';
import { LinkComponent, NavTarget } from '../../components/link/link.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { DokulinkItemBuilderFactory } from '../../components/dokulink/dokulinkItemBuilderFactory';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { DokulinkComponent } from '../../components/dokulink/dokulink.component';
import { Subscription } from 'rxjs';
import { CmisComponent } from '../../components/cmis/cmis.component';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-kompakt-grundbuchgeschaeft',
  templateUrl: './kompakt-grundbuchgeschaeft.component.html',
  styleUrls: ['./kompakt-grundbuchgeschaeft.component.scss'],
  imports: [LinkComponent, NgTemplateOutlet, DokulinkComponent, CmisComponent, KompaktGrundbuchgeschaeftPipe, AsyncPipe]
})
export class KompaktGrundbuchgeschaeftComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;

  @Input() item: GrundbuchgeschaeftItem;
  @Input() mitLinkGeschaeft = true;

  @Input() dokulink = true;

  isGeschaeftsmodulCapWebErweiterung: boolean;
  private subscription: Subscription = new Subscription();

  constructor(
    public formatConfigService: FormatConfigService,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.formatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isGeschaeftsmodulCapWebErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB);
      })
    );
    if (this.mitLinkGeschaeft === false) {
      return;
    }
    this.mitLinkGeschaeft = this.isGeschaeftsmodulCapWebErweiterung && this.item.timePoint.isNavigierbar;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
